import React from "react";

import "./VerifyEmailCta.css";

const VerifyEmailCta = (props) => {
  const { email } = props;
  return (
    <div className="verify-email-cta-container">
      <h1>Verify your email address</h1>
      <p>
        We've sent a verification email to <strong>{email}</strong>. Please
        click the link in the email to verify your email address, or click the button below to resend the email.
      </p>
      <div className="verify-email-cta-button">Resend Verification Email</div>
    </div>
  );
} 

export default VerifyEmailCta;